import { GET_CLUBS, GET_CLUBS_LOADING_STATUS } from 'constants/actionTypes';

const defaultState = {
  data: [],
};

function clubsReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_CLUBS:
      return {
        ...state,
        data: action.payload.clubs,
      };
    case GET_CLUBS_LOADING_STATUS: {
      return {
        ...state,
        [action.type]: action.payload,
      };
    }

    default:
      return state;
  }
}

export default clubsReducer;
